<div class="wrapper">
  <button class="close-button" mat-icon-button aria-label="close dialog" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
  <ng-template #contentContainer></ng-template>
</div>
